import { extendObservable } from 'mobx';

export default class AbstractRoot {
  constructor(currentUser, roles, localeStore) {
    if (new.target === AbstractRoot) {
      throw new TypeError('Cannot construct AbstractRoot instances directly');
    }

    /** **************************************************
         * Current user information. Ex:
         * this.user = { name: "User Name", roles: ["CEO", "Leader"] }
         **************************************************** */
    currentUser.roles = roles;
    this.user = currentUser;
    /** **********************************************
         * Localization
         *********************************************** */
    this.localeStore = localeStore;


    /** ***********************************************
         * Alerts
         ************************************************** */
    extendObservable(this, {
      alerts: [],
      // showAlert: false,
    });
    // this.alert = {type: "info", timeout: 500, headline: "", message: "", intlValues: {}};
  }

  generateAlert({
    type = 'info', timeout = 1500, headline = '', message = '', intlValues = {},
  }) {
    const alert = {
      type, timeout, headline, message, intlValues,
    };

    this.alerts.push(alert);

    // this.alert.type = type;
    // this.alert.timeout = timeout;
    // this.alert.headline = headline;
    // this.alert.message = message;
    // this.alert.intlValues = intlValues;

    // this.showAlert = true;
  }
}
